import { readFromDocument as readUtmFromCookie } from '@enter/utm';
import { gtmClient } from '@/lib/gtm/client';

/** 业务转化事件的公共参数。 */
export interface GtmCommonTrackingParams {
    user_id?: number;
    plan_type?: string;
}

/** 转化事件统一带首触 UTM（`custom_utm_*`），按 analytics 授权排队上报。 */
function submit(event: string, payload: Record<string, unknown>, onCommitted?: () => void): boolean {
    const utm = readUtmFromCookie();
    const utmParams = utm
        ? { custom_utm_source: utm.utm_source, custom_utm_medium: utm.utm_medium, custom_utm_campaign: utm.utm_campaign }
        : {};
    return gtmClient.submit(event, { ...utmParams, ...payload }, 'analytics', onCommitted);
}

/** 产品区的 GTM 转化事件；事件名与字段是投放侧的既有合同。 */
export const gtm = {
    trackUserLogin: (isNewUser: boolean, userId: number) => submit('user_login', { is_new_user: isNewUser, user_id: userId }),
    trackSignUp: (userId: number, onCommitted?: () => void) => submit('sign_up', { user_id: userId }, onCommitted),
    trackCreateProject: (action: 'create' | 'remix', params: GtmCommonTrackingParams = {}) =>
        submit('user_create_project', { action, ...params }),
    trackCreateProjectSuccess: (action: 'create' | 'remix', params: GtmCommonTrackingParams = {}) =>
        submit('user_create_project_success', { action, ...params }),
    trackPublishProject: (params: GtmCommonTrackingParams = {}) => submit('user_publish_project', { ...params }),
    trackPublishProjectSuccess: (params: GtmCommonTrackingParams = {}) => submit('user_publish_project_success', { ...params }),
    trackChatTurn: (turn: number, params: GtmCommonTrackingParams = {}) => submit('user_chat_turn', { turn, ...params }),
    pushToDataLayer: (event: string, payload: Record<string, unknown> = {}) => submit(event, payload),
} as const;
